import { AxiosRequestConfig } from "axios"

import { IAuthData } from "@/api/app/types/authorization"
import { IUserData, IUserGuideData, RateProps } from "@/api/app/types/user"
import request, { formatRequest } from "@/utils/request"

const APIApp = {
  /**
   * 关闭评论引导banner
   * @param {number} status 0 重置 1 永久关闭 2 当天关闭
   */
  closeGuideBanner(status: number) {
    return request.put("/v1/operate_logs/reviews_guide", {
      status,
    })
  },
  /**
   * 检查是否安装
   */
  checkInstall() {
    return formatRequest(request.get("/go-api/v1/auth/install_check"))
  },

  /**
   * 获取Canny JWT
   */
  getCannyJWT() {
    return request.get("/v1/integration/canny")
  },

  /**
   * 发送反馈
   * @param email
   * @param content
   */
  sendFeedback(email: string, content: string) {
    return request.post("/v1/user/feedback", {
      content,
      email,
    })
  },

  shopAddressInfo() {
    return formatRequest(request.get("/go-api/v1/com/shop/address"))
  },
  /**
   * 获取用户信息
   */
  user(params: {
    is_recommend?: string
    rt_ref_code?: string
    rt_ref_link?: string
  }) {
    return formatRequest(
      request.post<IUserData>("/go-api/v1/com/userInfo", params),
    )
  },

  /**
   * 获取用户信息Guide
   */
  userGuide() {
    return request.get<IUserGuideData>("/v1/user/guide")
  },

  userAuthorization(config?: AxiosRequestConfig) {
    return request.get<IAuthData>("/v1/authorization", config)
  },

  userBaseInfo() {
    return formatRequest(
      request.get<{ data: { balance: string } }>(
        "/go-api/v1/com/user/baseInfo",
      ),
    )
  },
  // 问卷调查信息
  survey() {
    // 调查问卷关闭 调查问卷提交
    return request.get("/go-api/v1/nps/info")
  },

  // 问卷调查操作 opt: 1-提交 2-关闭
  surveyMarkAction(type: number) {
    return request.post("/go-api/v1/nps/action", {
      opt: type,
    })
  },

  /**
   * 关闭banner
   * @param kind 类型
   * 1-关闭pp推荐banner 2-关闭订阅费引导banner
   * 3-关闭recharge_banner_logistics，4-关闭recharge_banner_bill
   */
  closeBanner(kind: number) {
    return formatRequest(
      request.post("/go-api/v1/com/closeBanner", {
        kind,
      }),
    )
  },
  /**
   * 更新默认语言
   * @param code
   */
  updateAdminLanguage(data) {
    return formatRequest(request.post("/go-api/v1/com/language/update", data), {
      success: {
        1000: t("OperationSuccessful"),
      },
    })
  },

  /**
   * 查询费率
   * @param
   */
  getRateByShippoForUser(params: RateProps) {
    return formatRequest(
      request.post("/v1/getRateByShippoForUser", params, {
        timeout: 30000,
      }),
    )
  },
  /**
   * 事件 1-预约演示点击事件, 默认为1, 2-展示预约演示banner
   */
  report(data: { event: 1 | 2; opt?: number }) {
    return formatRequest(request.post("/go-api/v1/com/event/report", data))
  },
  /**
   * 埋点
   */
  track(data: {
    event_name: string
    value?: any
    package_kind: number
    router: string
  }) {
    return formatRequest(
      request.post("/go-api/v1/com/event/track", {
        ...data,
        value: JSON.stringify(data.value ?? {}),
      }),
      {
        hideMsg: true,
      },
    )
  },

  // affiliate 推广码访问上报
  reportAffiliateAccess(data: {
    ref: string
    ref_link: string
    sign: string
    ip: string
    ua: string
  }) {
    return formatRequest(
      request.post("/go-api/v1/affiliate/access/report", data),
    )
  },
}

export default APIApp
